import axios from 'axios'

// export const getAllUsers = (params) => {
//   return axios.get('/clients', {params: params})
// }

export const getUser = (id, params) => {
  return axios.get('/clients/' + id, {params: params})
}

export const createUser = (data) => {
  return axios.post('/clients', data)
}

export const editUser = (id, data) => {
  return axios.put('/clients/' + id, data)
}

export const deleteUser = (id) => {
  return axios.delete('/clients/' + id)
}



// WEBPACK FOOTER //
// ./src/api/users.js